import * as React from 'react'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router'
import qs from 'qs'
import _ from 'lodash'

// components
import CatalogLayout from '../../../../components/ui/CatalogLayout/CatalogLayout'
import RewardsModal from '../../../../components/home/RewardsModal/RewardsModal'
import {
  BannerContent,
  BannerDescription,
  FormContainer,
  Heading,
  InputContainer,
  RewardsCatalogDescription,
  RewardsCatalogTitle,
  StyledBanner,
  StyledCatalogCard,
  StyledCatalogList,
  StyledCatalogPicker,
  StyledTextInput,
  StyledZingLogo,
} from './MainView.style'

// data
import filterString from '../../../../services/data/filterString'
import { REWARDS_REWARDS_CATALOG } from '../../../../services/data/errorNames.json'
import { DEFAULT_CATEGORY } from '../../../../services/data/rewardsCategory.json'
import { VOUCHERS } from '../../../../services/data/profilePages.json'

// analytics
import {
  setGAPageView,
  setGAEvent,
} from '../../../../services/analytics/google-analytics'

// controllers
import {
  doGetAllRewards,
  doGetAllRewardsMerchants,
  doGetRewardsMerchants,
  doGetRewardsByMerchant,
} from '../../../../controllers/Offers'

class MainView extends React.Component {
  debouncedSearch = _.debounce(search => {
    setGAEvent('rewards_merchant', 'search_merchant_rewards', search)
  }, 250)

  constructor(props) {
    super(props)

    const { location } = props.history

    const initialSearch = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    this.state = {
      apiKey: '',
      merchants: [],
      searchQuery: initialSearch.q || '',
      searched: [],
      selectedCatalog: {
        id: DEFAULT_CATEGORY,
      },
    }

    this.getRewardsMerchants(DEFAULT_CATEGORY)
  }

  componentWillMount() {
    this.retrieveInitialData()
  }

  componentDidMount() {
    const { location } = this.props
    setGAPageView(location.pathname)
  }

  componentDidUpdate(prevProps) {
    const { match, location } = this.props
    const { viewType, viewId } = match.params
    const {
      viewType: prevViewType,
      viewId: prevViewId,
    } = prevProps.match.params

    if (viewType !== prevViewType || viewId !== prevViewId) {
      this.displayModal()
    }

    if (location.pathname !== prevProps.location.pathname) {
      setGAPageView(location.pathname)
    }
  }

  getRewardsMerchants = async (id = 0) => {
    const {
      accessToken,
      history,
      errorList,
      setError,
      removeError,
    } = this.props

    if (errorList.length) {
      removeError(REWARDS_REWARDS_CATALOG)
    }

    const search = qs.parse(history.location.search, {
      ignoreQueryPrefix: true,
    })

    const pageLoadStart = Date.now()

    if (id === 0) {
      doGetAllRewardsMerchants({
        accessToken,
        onSuccess: ({ data }) => {
          this.setState({
            merchants: data.sort((a, b) =>
              a.name > b.name ? 1 : a.name < b.name ? -1 : 0,
            ),
            searched: search.q
              ? data.filter(merchant =>
                  merchant.name.toLowerCase().includes(search.q.toLowerCase()),
                )
              : [],
          })
          setGAEvent(
            'page',
            'loading_duration',
            'rewards_catalog',
            Date.now() - pageLoadStart,
          )
        },
        onError: error => {
          setError({
            name: REWARDS_REWARDS_CATALOG,
            error: error.message,
          })
        },
      })(null)
    } else {
      doGetRewardsMerchants({
        accessToken,
        selectedCatalogId: id,
        onSuccess: ({ data }) => {
          this.setState({
            merchants: data.sort((a, b) =>
              a.name > b.name ? 1 : a.name < b.name ? -1 : 0,
            ),
            searched: search.q
              ? data.filter(merchant =>
                  merchant.name.toLowerCase().includes(search.q.toLowerCase()),
                )
              : [],
          })
          setGAEvent(
            'page',
            'loading_duration',
            'rewards_catalog',
            Date.now() - pageLoadStart,
          )
        },
        onError: error => {
          setError({
            name: REWARDS_REWARDS_CATALOG,
            error: error.message,
          })
        },
      })(null, id)
    }
  }

  onCategoriesChange = e => {
    const catalogId = e.target.value
    const { setRewards, accessToken } = this.props

    doGetAllRewards({ accessToken, setRewards })('', catalogId)
  }

  retrieveInitialData = async () => {
    const { waitRenderServer, renderServer } = this.props

    waitRenderServer(true)

    await this.displayModal()

    renderServer()
  }

  displayModal = async () => {
    const {
      match,
      setRewardModalData,
      setRewardModalStatus,
      accessToken,
      // advanceAccount,
    } = this.props
    const { viewId } = match.params

    if (viewId) {
      setRewardModalStatus(1)
      try {
        await doGetRewardsByMerchant({ accessToken, setRewardModalData })(
          viewId,
        )
        setRewardModalStatus(0)
      } catch (e) {
        setRewardModalStatus(4)
      }
    } else {
      setRewardModalData({})
      setRewardModalStatus(null)

      setGAEvent('page', 'page_visit', 'rewards_catalog')
    }
  }

  handleClose = () => {
    const {
      push,
      baseUrl,
      setRewardModalData,
      setRewardModalStatus,
    } = this.props

    if (push) {
      push(`${baseUrl}`)
      setRewardModalData({})
      setRewardModalStatus(null)
    }
  }

  onCatalogChange = catalog => {
    this.setState({
      merchants: [],
    })
    this.getRewardsMerchants(catalog.id)

    setGAEvent('rewards', 'rewards_category', catalog.name)
  }

  onCatalogSearch = e => {
    const { merchants } = this.state

    const searched = merchants.filter(merchant => {
      const merchantName = merchant.name.toLowerCase()
      const searchQuery = e.target.value.toLowerCase()

      return merchantName.includes(searchQuery)
    })

    this.setState({
      searchQuery: e.target.value,
      searched,
    })

    this.debouncedSearch(e.target.value)
  }

  displayMyVouchers = data => {
    const {
      displayProfileModal,
      setProfileModalPage,
      setProfileModalDetailPage,
      accessToken,
    } = this.props

    if (accessToken) {
      displayProfileModal(true)
      setProfileModalPage(VOUCHERS)
      if (data) {
        setProfileModalDetailPage(data)
      }
    }
  }

  render() {
    const {
      history,
      showRewardModal,
      rewardModalData,
      rewardModalStatus,
      advanceAccount,
      accessToken,
      push,
      baseUrl,
      setLoyaltyPoints,
      loyaltyPoints,
      setLoyaltyPointsError,
      loyaltyPointsError,
      errorList,
      ...theProps
    } = this.props

    const {
      merchants,
      searched,
      searchQuery: searchQueryState,
      selectedCatalog,
    } = this.state

    const Banner = () => (
      <StyledBanner>
        <BannerContent>
          <BannerDescription>
            <StyledZingLogo />
            <RewardsCatalogTitle>Zing Rewards</RewardsCatalogTitle>
            <RewardsCatalogDescription>
              Unlock amazing rewards and incentives.
            </RewardsCatalogDescription>
          </BannerDescription>
        </BannerContent>
      </StyledBanner>
    )

    return (
      <CatalogLayout banner={Banner} accessToken={accessToken} {...theProps}>
        <Heading>
          <FormContainer>
            <StyledCatalogPicker
              initialCatalogId={selectedCatalog.id}
              toggleSearchError={() => {}}
              onChange={this.onCatalogChange}
            />

            <InputContainer>
              <StyledTextInput
                variant="search"
                whiteOut
                placeholder="What are you looking for?"
                onChange={this.onCatalogSearch}
                onKeyDown={this.onSearchKeyDown}
                value={searchQueryState}
              />
            </InputContainer>
          </FormContainer>
        </Heading>
        <StyledCatalogList
          dataSource={searchQueryState ? searched : merchants}
          loadingComponent={() => (
            <StyledCatalogCard
              loading
              error={errorList.find(
                error => error.name === REWARDS_REWARDS_CATALOG,
              )}
              errorMessage="Failed to load Rewards."
              onRetry={this.getRewardsMerchants}
            />
          )}
          renderItem={(merchant, index) => (
            <StyledCatalogCard
              id={index}
              key={merchant.id}
              data={merchant}
              push={push}
              to={`${baseUrl}/${merchant.id}`}
              onClick={() =>
                setGAEvent(
                  'item_clicks',
                  'view_rewards_catalog_item',
                  merchant.name,
                )
              }
            />
          )}
        />
        <RewardsModal
          show={showRewardModal}
          onClose={this.handleClose}
          data={rewardModalData}
          advanceAccount={advanceAccount}
          accessToken={accessToken}
          onLinkCard={this.displayAddCardForm}
          setLoyaltyPoints={setLoyaltyPoints}
          loyaltyPoints={loyaltyPoints}
          loading={rewardModalStatus}
          loyaltyPointsError={loyaltyPointsError}
          setLoyaltyPointsError={setLoyaltyPointsError}
          displayMyVoucher={this.displayMyVouchers}
        />
        {showRewardModal && rewardModalData.length && (
          <Helmet defaultTitle={rewardModalData[0].merchantName}>
            <meta
              property="og:title"
              content={rewardModalData[0].merchantName}
            />
            <meta
              property="og:description"
              content={filterString(rewardModalData[0].body)}
            />
            <meta property="og:image" content={rewardModalData[0].imageUrl} />
            <meta property="og:type" content="website" />
          </Helmet>
        )}
      </CatalogLayout>
    )
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default withRouter(MainView)
